var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogOut = function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.884 2.047a.6.6 0 0 1 0 1.2H4.728a1.48 1.48 0 0 0-1.479 1.478V19.27a1.48 1.48 0 0 0 1.479 1.479h4.156a.6.6 0 0 1 0 1.2H4.728A2.68 2.68 0 0 1 2.05 19.27V4.725a2.68 2.68 0 0 1 2.678-2.678zm6.848 4.33a.6.6 0 0 1 .848 0l5.195 5.195q.018.02.033.04a.593.593 0 0 1-.033.809l-5.195 5.195a.6.6 0 0 1-.848-.848l4.17-4.171H8.881a.6.6 0 0 1 0-1.2h11.021l-4.17-4.171a.6.6 0 0 1 0-.848"
  })));
};
export default SvgLogOut;